<div class="position-absolute notify"
(mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="notify-card">
        <div class="notify-card-header p-4 {{ animacaoLoader ? 'loader' : '' }} {{ darkMode ? 'dark' : '' }}">
            <h4 class="m-0 p-0">{{ titulo }}</h4>
            <button class="btn btn-sm btn-outline-secondary ms-4" (click)="fechar()">X</button>
        </div>
        <div class="notify-card-body px-4 py-2">
            <div class="m-0 p-0" [innerHTML]="mensagem"></div>
        </div>
        <div class="notify-card-footer py-2">
            <button class="btn btn-success me-2" (click)="fechar(true)">
                <i class="fa-solid fa-newspaper me-2"></i>
                Veja as Últimas Novidades
            </button>
        </div>
    </div>
</div>